export type TabKey =
  | 'new-order'
  | 'ready-to-ship'
  | 'shipping'
  | 'delivered'
  | 'cancel'
  | 'exchange'
  | 'return';

export const TAB_LIST: {
  key: TabKey;
  label: string;
  count: number;
  list: 'NewOrderStatusCountList' | 'ChangedOrderStatusCountList';
}[] = [
  { key: 'new-order', label: '주문완료', count: 0, list: 'NewOrderStatusCountList' },
  { key: 'ready-to-ship', label: '발송대기', count: 0, list: 'NewOrderStatusCountList' },
  { key: 'shipping', label: '배송중', count: 0, list: 'NewOrderStatusCountList' },
  { key: 'delivered', label: '배송완료', count: 0, list: 'NewOrderStatusCountList' },
  { key: 'cancel', label: '취소', count: 0, list: 'ChangedOrderStatusCountList' },
  { key: 'exchange', label: '교환', count: 0, list: 'ChangedOrderStatusCountList' },
  { key: 'return', label: '반품', count: 0, list: 'ChangedOrderStatusCountList' },
];

export const DEFAULT_TAB = 'new-order';

export interface MarketStoreListItem {
  MarketId: number;
  MarketName: string;
  MarketNameEnglish: string;
  MarketIconUrl: string;
  StoreId: string;
  StoreName: string;
  MarketAlias: string;
  MarketSeqNo: number;
  CoupangWingId?: string; // 쿠팡윙 ID (선택적)
}

export const TAB_CATEGORY_MAP = {
  'new-order': { OrderStatusType: '주문완료', title: 'newOrder' },
  'ready-to-ship': { OrderStatusType: '발송대기', title: 'newOrder' },
  shipping: { OrderStatusType: '배송중', title: 'newOrder' },
  delivered: { OrderStatusType: '배송완료', title: 'newOrder' },
  cancel: { OrderStatusType: '취소', title: 'changeOrder' },
  exchange: { OrderStatusType: '교환', title: 'changeOrder' },
  return: { OrderStatusType: '반품', title: 'changeOrder' },
} as const;

export const SELECT_ALL_MARKET: MarketStoreListItem = {
  MarketId: 0,
  MarketName: '전체',
  MarketNameEnglish: 'ALL',
  MarketIconUrl:
    'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketEtc_Purple.png',
  StoreId: '전체',
  StoreName: '전체',
  MarketAlias: '전체',
  MarketSeqNo: 0,
};
